module.exports = __webpack_public_path__ + "static/media/applenav-iphone.a16379de.PNG";